<template>
    <section>
      <h5 class="center-align">Batters</h5>
      <div class="table-responsive" v-if="createdDone">
        <table id="tableNameB" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
	      <thead>
	        <tr>
	          <th class="mdl-data-table__cell--non-numeric">Player Name</th>
            <th @click="setSortBattersCat('position','position')">Pos</th>
            <th @click="setSortBattersCat('team')">KBO Team </th>
            <th @click="setSortBattersCat('newAbs')">ABs</th>
            <th @click="setSortBattersCat('newHits')">Hits</th>
            <th @click="setSortBattersCat('newRuns')">Runs</th>
            <th @click="setSortBattersCat('newHrs')">HRs</th>
            <th @click="setSortBattersCat('newRBI')">RBI</th>
            <th @click="setSortBattersCat('newOps')">OPS</th>
            <th @click="setSortBattersCat('newSbs')">SBs</th>
	        </tr>
	      </thead>
	      <tbody>
	          <tr v-for="b of sortPastBatters" :key="b.link">
	            <td style="text-align: left"><a target="_blank" rel="noopener noreferrer" :href="'https://mykbostats.com'+b.link">{{ b.name }}</a></td>
              <td>{{ b.position }}</td>
	            <td>{{ b.team }}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newAbs  : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newHits : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newRuns : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newHrs  : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newRBI  : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newOps  : 0}}</td>
	            <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newSbs  : 0}}</td>
	          </tr>
	      </tbody>
	    </table>
    </div>
    <h5 class="center-align">Pitchers</h5>
      <div class="table-responsive" v-if="createdDone">
        <table id="tableNameP" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead>
          <tr>
            <th class="mdl-data-table__cell--non-numeric">Player Name</th>
            <th >KBO Team </th>
            <th @click="setSortPitchersCat('newIp')">IPs</th>
            <th @click="setSortPitchersCat('newWins')">Wins</th>
            <th @click="setSortPitchersCat('newKs')">Ks</th>
            <th @click="setSortPitchersCat('newEarnedRuns')">ER</th>
            <th @click="setSortPitchersCat('newSaves')">Saves</th>
            <th @click="setSortPitchersCat('newWhip')">WHIP</th>
            <th @click="setSortPitchersCat('newEra')">ERA</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="b of sortPastPitchers" :key="b.link">
              <td style="text-align: left"><a target="_blank" rel="noopener noreferrer" :href="'https://mykbostats.com'+b.link">{{ b.name }}</a></td>
              <td>{{ b.team }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newIp.toFixed(3) : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newWins : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newKs : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newEarnedRuns : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newSaves : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newWhip : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newEra : 0 }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
  import { db } from '../db'

 export default {
  props: {
   tableName: "",
   weekKey: { 
   	type: String, // not 'string'
    required: true,
    default: "season"
   },

   players: { required:true },
   
  },
  data() {
    return {
      pastBatters: {},
      pastPitchers: {},
      createdDone: false,
      sortBattersCat: "team",
      sortPitchersCat: "team"
    }
  },
  computed: {
    sortPastPitchers() {
      let ordered = {};
      Object.keys(this.pastPitchers).sort( (a,b) => this.sortPitchersByCat(a,b) ).forEach(key => {
        ordered[key] = this.pastPitchers[key];
      });
      return ordered
      
    }, 
    sortPastBatters() {
      let ordered = {};
      Object.keys(this.pastBatters).sort( (a,b) => this.sortBattersByCat(a,b) ).forEach(key => {
        ordered[key] = this.pastBatters[key];
      });
      return ordered
    }, 
  },
  methods : {
    isPitcher(p){
      return p=='pitcher1' || p=='pitcher2' || p=='pitcher3' || p=='pitcher4' || p=='pitcher5' || p=='pitcher6'
    },
    processPlayers() {
      this.pastPitchers = {}
      this.pastBatters = {}

      for (let pos in this.players){
        if (this.isPitcher(pos)){
          db.ref('/pitchers/players/'+this.players[pos]).once('value', (b) => {
            this.pastPitchers[b.key] = b.val()
          })

        } else{
          db.ref('/batters/players/'+this.players[pos]).once('value', (b) => {
            this.pastBatters[b.key] = b.val()
          })      
        }
      }
    },
    setSortPitchersCat(cat){
      this.sortPitchersCat = cat
    },
    setSortBattersCat(cat){
      this.sortBattersCat = cat
    },
    sortBattersByCat(a,b){
      let tmpb = 0
      if(this.pastBatters[b].season && this.pastBatters[b].season[this.weekKey]){
        tmpb = this.pastBatters[b].season[this.weekKey][this.sortBattersCat]
      }

      let tmpa = 0
      if(this.pastBatters[a].season && this.pastBatters[a].season[this.weekKey]){
        tmpa = this.pastBatters[a].season[this.weekKey][this.sortBattersCat]
      }
      
      return tmpb - tmpa
    },
    sortPitchersByCat(a,b){
      let tmpb = (this.pastPitchers[b].season && this.pastPitchers[b].season[this.weekKey]) ? this.pastPitchers[b].season[this.weekKey][this.sortPitchersCat] : 0
      let tmpa = (this.pastPitchers[a].season && this.pastPitchers[a].season[this.weekKey]) ? this.pastPitchers[a].season[this.weekKey][this.sortPitchersCat] : 0
      return tmpb - tmpa
    },
  },
  created() {
    this.processPlayers()
    this.createdDone = true//why is this necessary??
  },
  watch: {
    players : {
      immediate: true,
      handler(players) {
        this.processPlayers()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/PastPlayerTables.vue